import { FC, useState } from "react";

import { selectCollaborators } from "../../../store/collaborators/selectors";
import useShallowSelector from "../../../hooks/useShalowSelector";
import Collaborator from "./../Collaborator";
import OwnerItem from "./OwnerItem";

import styles from "./styles.module.scss";

const Content: FC = () => {
    const collaborators = useShallowSelector(selectCollaborators);

    const [scrolled, setScrolled] = useState<boolean>(false);

    return (
        <main className={styles.main}>
            <div
                className={styles.collaborators}
                onScroll={() => {
                    setScrolled(true);
                }}
            >
                <OwnerItem withCollaborators={collaborators.length !== 0} />

                {collaborators.map(({ id, email, role, status }) => (
                    <Collaborator
                        key={id}
                        id={id}
                        email={email}
                        role={role}
                        status={status}
                        scrolled={scrolled}
                        clearScrolled={() => setScrolled(false)}
                    />
                ))}
            </div>
        </main>
    );
};

export default Content;
